import { useTheme } from "@emotion/react"
import { Box, Button, Grid, Typography } from "@mui/material"
import { IconExclamationCircle } from "@tabler/icons-react"
import { transparentize } from "polished"
import { DealershipLoginModal } from "~/components/DealershipLoginModal"
import { useToggle } from "~/hooks"

export const DealershipLoginBanner: React.FC = () => {
  const theme = useTheme()
  const isLowerSm = theme.breakpoints.down('sm')

  const { isTrue: isModalVisible, setIsTrue: setIsModalVisible } = useToggle()

  return (
    <>
      <Box
        sx={{ 
          width: `100%`,
          minHeight: '300px',
          padding: isLowerSm ? '2rem 1rem' : '3rem 2rem',
          border: `1px solid #F37704`,
          background: '#FFD4AC',
          borderRadius: '1.2rem'
        }}>
          <Grid container spacing='0 2rem'>
            <Grid sm={12} md={8} lg={6} item>
              <Box sx={{ padding: '1.2rem 0' }}>
                <Box sx={{  display: 'flex', alignItems: 'center', gap: '.4rem' }}>
                  <IconExclamationCircle color={theme.palette.grey[800]} size={30} />
                  <Typography sx={{ color: theme.palette.grey[800], fontSize: isLowerSm ? '1rem' : '1.1rem', fontWeight: 500 }}>
                    PRECISAMOS DE ACESSO À SUA CONCESSIONÁRIA
                  </Typography>
                </Box>
                <Typography sx={{ color: theme.palette.grey[600], fontSize: isLowerSm ? '1.1rem' : '1.2rem', paddingTop: '.6rem' }}>
                  Nosso faturamento mensal depende do seu consumo na concessionária.
                </Typography>
                <Typography sx={{ color: '#DC6B03', fontSize: '.9rem', paddingTop: '.6rem', maxWidth: '460px', paddingBottom: '1.2rem' }}>
                  Compartilhe seus dados de acesso para receber suas contas em dia; eles serão tratados com total segurança e confidencialidade.
                </Typography>
                <Button
                  onClick={() => setIsModalVisible(true)}
                  sx={{
                    background: '#F37704',
                    '&:hover': { background: transparentize('0.20', '#F37704') },
                    color: theme.palette.common.white
                  }}
                >
                  INFORMAR DADOS DE ACESSO
                </Button>
              </Box>
            </Grid>
          </Grid>
      </Box>
      <DealershipLoginModal isVisible={isModalVisible} setIsVisible={setIsModalVisible} />
    </>
  )
}